<div class="search-display-container d-flex flex-column h-100 overflow-hidden">
  @if (chatSession.agentId()) {
    <lib-chat-panel-hdr
      [title]="agentLabel"
      [agents]="agents"
      [selectedAgentId]="chatSession.agentId() ?? ''"
      [showMinimize]="false"
      (newChatRequested)="startNewChat()"
      (agentChange)="onAgentChange($event)" />
    <div class="ai-view-chat-wrapper flex-fill min-h-0 d-flex justify-content-center overflow-hidden">
      @for (key of [chatSession.threadId()]; track key) {
        <lib-chat-container
          class="ai-view-chat-container flex-fill min-h-0"
          [agentId]="chatSession.agentId() ?? ''"
          [idleConfig]="activeAgent()?.idleState"
          [threadId]="key" />
      }
    </div>
  } @else {
    <div class="no-agent-configured d-flex flex-column align-items-center justify-content-center flex-fill gap-2">
      <p>No agent configured for this panel</p>
    </div>
  }
</div>
